"use client"

import * as React from "react"
import { Toaster } from "sonner"

const Toast = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>((props, _ref) => {
  return <Toaster />
})
Toast.displayName = "Toast"

export { Toast }